import router from "js/src/config/router.js";

import Vue from "vue";
export default new Vue({
  router,
});
